import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import classNames from "classnames";
import { handleGetRequest } from "../../services/GetTemplate";

function ZDropdownLink({ onChange, values, isFormFieldValid, getFormErrorMessage, keyName, placeholder, optionLabel, valueOption, url, label, required, linkId }) {
    const [options, setOptions] = useState([]);
    const [loading, setloading] = useState(false);
    const placeholderMgs = loading ? "Loading..." : placeholder || "Select";

    const getDropdownOptions = async () => {
        setloading(true);
        try {
            const res = await handleGetRequest(url + "/" + linkId);
            const options = res.data.map((item) => {
                return {
                    label: item[optionLabel],
                    value: item[valueOption],
                };
            });
            setOptions(options);
        } catch (err) {
            setOptions([]);
            console.log(err);
        } finally {
            setloading(false);
        }
    };

    useEffect(() => {
        if (linkId !== undefined && linkId !== null && linkId !== "") {
            getDropdownOptions();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [linkId]);

    return (
        <>
            <label htmlFor={keyName} className={classNames({ "p-error": isFormFieldValid(keyName.toString()) }, "Label__Text")}>
                {label} {required && <span className="Label__Required">*</span>}
            </label>
            <Dropdown disabled={loading} id={keyName} placeholder={placeholderMgs} name={keyName} value={values[keyName]} options={options} onChange={onChange} className={classNames({ "p-invalid": isFormFieldValid(keyName.toString()) }, "Dropdown__Round")} />
            {getFormErrorMessage(keyName.toString())}
        </>
    );
}

export default ZDropdownLink;
